var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShare = function SvgShare(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M10.884 15.811a.2.2 0 0 0 .24-.047l5.81-6.192a.28.28 0 0 0 0-.375l-5.808-6.13a.2.2 0 0 0-.24-.045.26.26 0 0 0-.133.233v3.43a6.92 6.92 0 0 0-4.789 1.567 8.95 8.95 0 0 0-2.888 7.82v.015l.117.712a.24.24 0 0 0 .175.2.2.2 0 0 0 .043 0 .22.22 0 0 0 .186-.116l.35-.62c2.438-4.303 5.621-4.366 6.8-4.218v3.522a.26.26 0 0 0 .137.244"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export default ForwardRef;